<template>
  <span class="md:hidden">{{ mobileLabel }}</span>
  <span class="hidden md:inline"><slot /></span>
</template>

<script>
export default {
  props: {
    mobileLabel: {
      type: String,
      required: true,
    },
  },
}
</script>
